import styled from 'styled-components';
import { layout, media } from '@prisjakt/ui-base';

export const StyledClickoutWrapper = styled.div`
  display: flex;
  height: 100%;

  ${media.mediumDown`
    display: none;
  `}
`;

export const StyledStoreWrapper = styled.div`
  margin: ${layout.measurements.spacing100};
  text-align: right;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: ${layout.measurements.spacing025};
`;

export const StyledPriceWrapper = styled.div`
  margin: ${layout.measurements.spacing100};
  display: flex;
  flex-direction: column;
  gap: ${layout.measurements.spacing025};
  text-align: right;
  min-width: 147px;
  align-items: flex-end;
`;

export const StyledVerticalLine = styled.div`
  border-left: 1px solid rgba(5, 37, 46, 0.12);
  margin: ${layout.measurements.spacing100} ${layout.measurements.spacing100};
`;

export const StyledIconWrapper = styled.div`
  display: flex;
  margin-bottom: -5px;
`;
